/** @file URL path of a project's editor page (/p/<encoded id>). */

/** Inverse of parseRoute for editor routes. */
export function projectPath(id: string): string {
  return `/p/${encodeURIComponent(id)}`;
}
